<template>
  <asc-page-loading-indicator
    :loading="isAnserToolLoading && !apiPageFailure.length"
  >
    <v-container fluid class="asc-anser-tool-container pa-4">
      <v-row no-gutters>
        <v-col cols="12" sm="12">
          <template v-if="isAnserToolPageActive">
            <asc-page-header>
              <template #pageTitle>
                <asc-page-title title="ANALYTICS DEVELOPER" />
              </template>
            </asc-page-header>
            <asc-anser-tool-template
              :signatures="signatures"
              :loading="isAnserToolLoading"
              @onPlatformSelect="handlePlatformSelection"
            />
          </template>
          <template v-else>
            <asc-page-coming-soon
              label="Analytics developer Page Coming Soon!"
            />
          </template>
        </v-col>
      </v-row>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscAnserToolTemplate from '../../../templates/AscAnserToolTemplate.vue'

import AscPageLoadingIndicator from '../../../molecules/AscPageLoadingIndicator.vue'
import AscPageComingSoon from '../../../molecules/AscPageComingSoon.vue'

import AscPageHeader from '../../../atoms/AscPageHeader.vue'
import AscPageTitle from '../../../atoms/AscPageTitle.vue'

import AppFeatureFlags from '@/utilities/appFeatureFlags'

import { mapState, mapGetters, mapActions } from 'vuex'
import { ANSER_TOOL_CONSTS as ATC, LOOKUP_CONSTS as LC } from '@/stores/consts'

export default {
  name: 'AscAnserToolContainer',

  components: {
    AscPageLoadingIndicator,
    AscPageHeader,
    AscPageTitle,
    AscPageComingSoon,
    AscAnserToolTemplate,
  },

  data() {
    return {}
  },

  computed: {
    ...mapState({ apiPageFailure: 'apiPageFailure' }),
    ...mapState(LC.NAMESPACE, ['aircraftsLoading', 'masterModelsLoading']),
    ...mapState(ATC.NAMESPACE, ['signaturesLoading', 'signatures']),

    ...mapGetters(ATC.NAMESPACE, ['mappedGFUserAirlinesWithMasterModels']),

    isAnserToolPageActive() {
      return AppFeatureFlags.getAnserToolPage()
    },

    isAnserToolLoading() {
      return (
        this.aircraftsLoading ||
        this.masterModelsLoading ||
        this.signaturesLoading
      )
    },
  },

  watch: {
    mappedGFUserAirlinesWithMasterModels: {
      deep: true,
      handler(newValue) {
        this[ATC.GET_SIGNATURES](newValue)
      },
    },
  },

  mounted() {
    this[ATC.GET_SIGNATURES](this.mappedGFUserAirlinesWithMasterModels)
  },

  methods: {
    ...mapActions(ATC.NAMESPACE, [ATC.GET_SIGNATURES]),

    handlePlatformSelection(event, selected) {
      this.$router
        .push({
          name: 'Signatures',
          query: {
            airline: selected.icaoCode,
            airlineDisplayName: selected.airlineDisplayName,
            platform: selected.text,
            lastModifiedDate: selected.lastModifiedDate,
            airlineId: selected.airlineId,
            masterModelId: selected.masterModelId,
          },
        })
        .catch(err => {
          throw new Error(`Problem navigating: ${err}.`)
        })
    },
  },
}
</script>
